import {createSelector} from 'reselect';

export const workersBranch = state => state.workers;

export const getMiningWorkers = createSelector(
  workersBranch,
  workers => workers.results
);

export const getMinersLoading = createSelector(
  workersBranch,
  workers => workers.loading
);

export const getUpdatedTime = createSelector(
  workersBranch,
  workers => workers.updatedAt
);

export const getWorkersCount = createSelector(
  getMiningWorkers,
  workers => {
    const active = workers.filter(worker => worker.active);
    return {
      all: workers.length,
      active: active.length,
      inactive: workers.length - active.length,
    };
  }
);



// WEBPACK FOOTER //
// /src/redux/selectors/workers.js